module.exports = __webpack_public_path__ + "static/img/AU.70e564a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/AU.png
// module id = BN1X
// module chunks = 2